////////////////////
const template = /*html*/ `


<div class="c-tile-product">
    <a :href="productUrl" class="c-tile-product_link">
        <span class="u-screen-reader-text">
            {{ goToProductLabel }}
        </span>
    </a>

    <div class="c-tile-product_img">
        <figure class="c-figure">
            <span class="c-figure_inner || c-lazy">
                <img
                    ref="image"
                    class="c-figure_image || c-lazy_image is-inview"
                    :src="imageUrl | imageUrl"
                    :alt="imageAlt"
                    loading="lazy"
                    width="1200"
                    height="1200"
                >
            </span>
        </figure>

        <img
            class="c-figure_image || c-tile-product_alternative-image"
            :alt="imageAlt"
            :src="alternativeImageUrl | imageUrl"
            width="1200"
            height="1200"
            loading="lazy"
            v-if="alternativeImageUrl"
        >

        <div class="c-tile-product_button">
            <a
                :href="productUrl"
                class="c-button -white || c-tile-product_button_add"
                :aria-label="goToProductLabel"
            >
                <span class="c-button_label">{{ goToProductLabel }}</span>
            </a>
        </div>
    </div>
    <div class="c-tile-product_content">
        <div class="c-tile-product_content_inner">
            <h3 class="c-tile-product_content_title">
                {{ title }}
            </h3>
        </div>

        <p class="c-tile-product_content_category">
            <span class="c-tag -alert" v-if="!isAvailable">
                [{{notAvailableLabel}}]
            </span>
        </p>

        <div class="c-tile_product_content_price">
            {{ currentPrice }}
        </div>
    </div>
</div>
`;

////////////////////
// Scripts
////////////////////
import { format_price } from "../../utils/cart-utils";
import { triggerLazyloadCallbacks } from "../../utils/image";
// import { lazyLoadImage } from "../../utils/image";

const IMAGE_WIDTH = 1200;
const IMAGE_HEIGHT = 1200;
const THUMBNAIL_WIDTH = IMAGE_WIDTH

export default function VueProductRecommendationsItem(moduleInstance) {

    Vue.component("product-recommendations-item", {

        template,

        props: {
            title: {
                type: String,
                required: true
            },
            images: {
                type: Array,
                default: () => []
            },
            handle: {
                type: String,
                required: true
            },
            createdAt: {
                type: String,
                required: true
            },
            priceRange: {
                type: Object,
                default: () => {}
            },
            currencyIsoCode: {
                type: String,
                required: true
            },
            currencySymbol: {
                type: String,
                required: true
            },
            availableForSale: {
                type: Boolean,
                default: false
            },
            notAvailableLabel: {
                type: String,
                required: true
            },
            newLabel: {
                type: String,
                required: true
            },
            addToCartLabel: {
                type: String,
                required: true
            },
            goToProductLabel: {
                type: String,
                required: true
            },
            variantsObj: {
                type: Object,
                default: () => {}
            },
            currentLangCode: {
                type: String,
                required: true
            },
            productUrl: {
                type: String,
                required: true
            },
            imageUrl: {
                type: String,
                required: true
            },
            alternativeImageUrl: {
                type: String,
                required: false
            }
        },

        data() {
            return {
                imageAlt: ''
            };
        },

        computed: {
            isAvailable() {
                return this.availableForSale
            },

            isNew() {
                const created = new Date(this.createdAt);
                const now = new Date(Date.now());
                const difference = created.getTime() - now.getTime();

                const seconds_difference = difference / 1000;
                if (Math.abs(seconds_difference) < 1296000) {
                    return true
                } else {
                    return false
                }
            },

            currentPrice() {
                return format_price(this.priceRange.minVariantPrice, this.currencySymbol, this.currencyIsoCode)
            },

            canBeAddedToCart() {
                return this.variantsObj?.edges?.length < 2
            }
        },

        mounted() {
            this.$nextTick(() => {
                triggerLazyloadCallbacks();
            })
        },

        methods: {
            onAddToCart() {
                const variantId = this.variantsObj?.edges?.[0]?.node?.id

                if (variantId) {
                    moduleInstance.call(
                        'addToCart',
                        {
                            productGID: variantId,
                            quantity: 1,
                            openCart: true
                        },
                        'Cart'
                    )
                }
            }
        },
        filters: {
            imageUrl: function(value) {
                if (typeof value != "string") return value;
                return `${value}&width=${THUMBNAIL_WIDTH}&height=${THUMBNAIL_WIDTH}&crop=center`;
            },
        },
    });
}
